import { render, staticRenderFns } from "./richTextForm.vue?vue&type=template&id=26362515&scoped=true"
import script from "./richTextForm.vue?vue&type=script&lang=js"
export * from "./richTextForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26362515",
  null
  
)

export default component.exports